import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTooltip as ClbTooltip_ } from '@celebration/design-system/dist/lib/tooltip';
export const ClbTooltip = createComponent({
    tagName: ClbTooltip_.tagName,
    elementClass: ClbTooltip_,
    react: React,
    events: {},
});
//# sourceMappingURL=index.js.map